import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
  tag: {
    isBusy: false,
    data: null,
    error: null,
    loadingTags: []
  },
  project_tags: {
    isBusy: false,
    data: null,
    error: null
  }
};

const getters = {
  tagsErrors: (state) => {
    return state.tag.error;
  },
  tagIsBusy: (state) => {
    return state.tag.isBusy;
  }
}

const mutations = {
  CLEAR_ERROR: (state) => {
    state.tag.error = null;
  },
  LOAD_TAG_BUSY: (state, payload) => {
    state.tag.isBusy = payload;
  },
  LOAD_TAG_SUCCESS: (state, payload) => {
    state.tag.data = payload;
    state.tag.error = null;
  },
  LOAD_TAG_FAIL: (state, payload) => {
    state.tag.data = null;
    state.tag.error = payload;
  },
  //TAGS BY PROJECT
  LOAD_PROJECT_TAGS_BUSY: (state, payload) => {
    state.project_tags.isBusy = payload;
  },
  LOAD_PROJECT_TAGS_SUCCESS: (state, payload) => {
    state.project_tags.data = payload;
    state.project_tags.error = null;
  },
  LOAD_PROJECT_TAGS_FAIL: (state, payload) => {
    state.project_tags.data = null;
    state.project_tags.error = payload;
  },
  UPDATE_PROJECT_TAG_BUSY(state, payload) {
    state.project_tags.isBusy = payload;
  },
  UPDATE_PROJECT_TAG_SUCCESS(state, payload) {
    state.project_tags.data = payload;
    state.project_tags.error = null;
  },
  UPDATE_PROJECT_TAG_FAIL: (state, payload) => {
    state.project_tags.error = payload;
    state.project_tags.data = null;
  },
  LOADING_TAG(state, payload) {
    state.tag.loadingTags = [...state.tag.loadingTags, ...payload];
  },
  LOADING_SUCCESS_TAG(state, payload) {
    // if its empty array, empty the state
    state.tag.loadingTags = Array.isArray(payload) ? state.tag.loadingTags?.filter(t => payload?.length && !payload?.includes(t)) : state.tag.loadingTags?.filter(t => t !== payload);
  }
};

const actions = {
  getTag: ({ commit, rootState }, { projectId, tagId }) => {
    commit('LOAD_TAG_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios
      .get(`${API_HOST}/analysis/editor/${projectId}/tag/${tagId}`, config)
      .then(response => {
        commit('LOAD_TAG_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_TAG_FAIL', error)
      })
      .finally(() => commit('LOAD_TAG_BUSY', false));
  },

  getTagOutlets: ({ commit, rootState }, { projectId, tagId }) => {
    return new Promise((result, reject) => {
      commit('LOAD_TAG_BUSY', true);
      const { accessToken } = rootState.user.user.data;
      const config = {
        headers: { Authorization: `Token token=${accessToken}` }
      };
      Axios
        .get(`${API_HOST}/analysis/${projectId}/tags/tag/${tagId}/outlets`, config)
        .then(response => {
          result(response.data.data.outlets);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });

          console.error(error);
          commit('LOAD_TAG_FAIL', error);
        })
        .finally(() => commit('LOAD_TAG_BUSY', false));
    });
  },

  addTag: ({ commit, rootState }, { projectId, tag }) => {
    commit('LOAD_TAG_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return new Promise ((resolve, reject) => {
      Axios
        .post(`${API_HOST}/analysis/editor/${projectId}/tag`, tag, config)
          .then(response => {
            commit('LOAD_TAG_SUCCESS', response.data);
            resolve();
          })
          .catch(error => {
            if (!error.response.data.message) {
              Vue.notify({
                group: 'store_notifications',
                type: 'error',
                text: i18n.t('messages.request.error')
              });
            }
      
            commit('LOAD_TAG_FAIL', error.response.data);

            reject(error.response.data);
          })
          .finally(() => commit('LOAD_TAG_BUSY', false));
    });

  },

  updateTag: ({ commit, rootState }, { projectId, tag }) => {
    commit('LOAD_TAG_BUSY', true);
    commit('LOADING_TAG', [tag?.key]);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return new Promise ((resolve, reject) => {
      Axios
        .put(`${API_HOST}/analysis/editor/${projectId}/tag`, tag, config)
          .then(response => {
            commit('LOAD_TAG_SUCCESS', response.data);
            resolve(response.data);
          })
          .catch(error => {
            if (!error.response.data.message) {
              Vue.notify({
                group: 'store_notifications',
                type: 'error',
                text: i18n.t('messages.request.error')
              });
            }
            // if err, remove that key from (state.tag.loadingTags) which previously added in the tag loading state
            // by triggering the loading tag success state
            commit('LOADING_SUCCESS_TAG', tag?.key);

            commit('LOAD_TAG_FAIL', error.response.data);
            reject(error.response.data);
          })
          .finally(() => commit('LOAD_TAG_BUSY', false));
    });
  },

  toggleTagPin: async ({ commit, rootState }, { projectId, tag }) => {
    commit('LOAD_TAG_BUSY', true);
    commit('LOADING_TAG', [tag?.key]);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    const pinStatus = !tag.pinned;

    try {
      const response = await Axios.patch(
        `${API_HOST}/analysis/editor/${projectId}/tag/toggle_pin`,
        { pinned: pinStatus, tag },
        config
      );
      
      commit('LOAD_TAG_SUCCESS', response.data);
      return response.data;
    } catch (error) {
      if (!error.response.data.message) {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });
      }
      commit('LOADING_SUCCESS_TAG', tag?.key);

      commit('LOAD_TAG_FAIL', error.response.data);
      throw error.response.data;
    } finally {
      commit('LOAD_TAG_BUSY', false);
    }
  },

  deleteTag: ({ commit, rootState }, { projectId, tagKey }) => {
    commit('LOAD_TAG_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios
      .delete(`${API_HOST}/analysis/editor/${projectId}/tag/${tagKey}`, config)
      .then(response => {
        commit('LOAD_TAG_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_TAG_FAIL', error)
      })
      .finally(() => commit('LOAD_TAG_BUSY', false));
  },

  getTagsByProject: ({ commit, rootState }, { projectUid}) => {

    console.log('projectUid ', projectUid)
    commit("LOAD_PROJECT_TAGS_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(`${API_HOST}/analysis/${projectUid}/tags/`, config)
      .then(response => {
        commit("LOAD_PROJECT_TAGS_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_PROJECT_TAGS_FAIL", error);
      })
      .finally(() => commit("LOAD_PROJECT_TAGS_BUSY", false));
  },

  updateTagByProject: ({ commit, rootState }, { projectUid, newValue }) => {
      commit("UPDATE_PROJECT_TAG_BUSY", true);

      const body = {
        ...newValue,
      };

      const { accessToken } = rootState.user.user.data;
      const config = {
        headers: { Authorization: `Token token=${accessToken}` }
      };

      Axios.put(
        `${API_HOST}/analysis/${projectUid}/tags/${newValue.id}/update`,
        body,
        config
      )
        .then(response => {
          commit("UPDATE_PROJECT_TAG_SUCCESS", response.data);
        })
        .catch(error => {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });

          console.error(error);
          commit("UPDATE_PROJECT_TAG_FAIL", error);
        })
        .finally(() => commit("UPDATE_PROJECT_TAG_BUSY", false));
  },

  clearError: ({commit}) => {
    commit('CLEAR_ERROR');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};